module.exports = __webpack_public_path__ + "static/media/grey-tooltip.41031691.svg";